import { AfterViewInit, Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { LayoutService } from '../../layout/services/layout.service';

@Directive({
    selector: '[appMaxHeightViewport]',
})

export class MaxHeightViewportDirective implements AfterViewInit {
    private el = inject(ElementRef);
    private readonly layoutService = inject(LayoutService);

    @Input() bottomMargin = 20;
    @Input() topMargin = 56;
    @Input() topOffset?: number;

    ngAfterViewInit() {
        setTimeout(() => {
            this.calculateMaxHeight();
        }, 500);
    }

    @HostListener('window:resize')
    onResize() {
        this.calculateMaxHeight();
    }

    private calculateMaxHeight(): void {
        const element = this.el.nativeElement;

        const parent = element.parentElement;
        if (!parent) return;

        const parentRect = parent.getBoundingClientRect();
        const parentTop = this.topOffset !== undefined ? this.topOffset : parentRect.top;

        const maxHeight = window.innerHeight - parentTop - (this.layoutService.isHorizontal() ? this.topMargin : 0) - this.bottomMargin;
        element.style.maxHeight = `${Math.max(maxHeight, 100)}px`;
        element.style.overflowY = 'auto';
    }
}
